import isBlank from './is_blank';

export default function isPresent(object) {
  return !isBlank(object);
};